module.exports = __webpack_public_path__ + "static/media/waiting_icon.d84aa1cd.svg";